import React from 'react';
import PropTypes from 'prop-types';

import newBatch from '~/common/images/new-batch-black.svg';

// Import Local Styles
import styles from './new-batch.css';

const NewBatch = ({ onClick, fetching }) => {
    return (
        <button
            className={styles.btn}
            id="number__new-batch"
            onClick={onClick}
            type="button"
        >
            <img
                alt="New Batch"
                className={`${styles.image} ${fetching ? styles['image--fetching'] : ''}`}
                src={newBatch}
                title="New Batch"
            />
            New Batch
        </button>
    );
};

NewBatch.propTypes = {
    onClick: PropTypes.func,
    fetching: PropTypes.bool
};

export default NewBatch;
